import React from 'react';
import { Navigate } from 'react-router';
import { Box, CircularProgress } from '@mui/material';
import { useSession } from 'src/SessionContext';

interface RoleBasedRoutesProps {
  staffRoutes: React.ReactNode;
  talentRoutes: React.ReactNode;
  clientRoutes?: React.ReactNode;
}

export const RoleBasedRoutes: React.FC<RoleBasedRoutesProps> = ({ staffRoutes, talentRoutes, clientRoutes }) => {
  const { session, loading } = useSession() || {};
  const { user, accountType } = session || {};

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (accountType === 'Staff') {
    return <>{staffRoutes}</>;
  } else if (accountType === 'Talent') {
    return <>{talentRoutes}</>;
  } else if (accountType === 'Client' && clientRoutes) {
    return <>{clientRoutes}</>;
  } else {
    return <Navigate to="/no-access" replace />;
  }
};
